import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        fundType: 'equity',
        channl: '国信证券',
    },
    actions: {
        //`异步更改数据`
        changeType({ commit }, params) {
            commit('setFundType', params)
        },
        changeChannl({ commit }, params) {
            commit('setChannl', params)
        },
    },
    mutations: {
        setFundType: (state, data) => {
            state.fundType = data
            // localStorage.setItem('token', data);
        },
        setChannl: (state, data) => {
            state.channl = data
            // localStorage.setItem('token', data);
        },
    },
})
